<template>
  <vs-popup
    v-if="orderInfo"
    classContent="popup-example"
    title="Order Details"
    :active.sync="showDialog"
  >
    <div class="order-details p-4">
      <div class="mb-6 border-b pb-4">
        <h3 class="text-lg font-bold mb-4">Order Information</h3>

        <div class="grid grid-cols-2 gap-4">
          <div>
            <!-- <div class="font-medium text-gray-600"></div> -->
            <vs-chip
              style="width: 135px"
              v-bind:class="orderInfo.rowstatus.toLowerCase().replace(' ', '')"
            >
              {{ orderInfo.rowstatus.toUpperCase() }}
            </vs-chip>
          </div>
          <div>
            {{ orderInfo.confirm_date? `Comfirmed on ${orderInfo.confirm_date}`:'' }}
          </div>
          <div>
            <div class="font-medium text-gray-600">Order Number</div>
            <div>{{ orderInfo.order_id || 'N/A' }}</div>
          </div>
          <div>
            <div class="font-medium text-gray-600">Reference Number</div>
            <div>{{ orderInfo.unique_id || 'N/A' }}</div>
          </div>
        </div>
      </div>

      <div class="mb-6 border-b pb-4">
        <h3 class="text-lg font-bold mb-4">Shipping Info</h3>
        <div v-if="address">
          <div class="mb-1">{{ address.firstname }} {{ address.lastname }}</div>
          <div class="mb-1"> {{address.phone }}</div>
          <div class="mb-1">
            {{ address.address }} {{ address.subdistrict }} {{ address.district }} {{ address.postcode }}
          </div>
          <div class="mb-1">{{ address.recipientnote }}</div>
        </div>
        <div v-else class="text-gray-500">
          -
        </div>
      </div>

      <div class="mb-6">
        <h3 class="text-lg font-bold mb-4">Items</h3>
        <template v-if="products && products.length">
          <div v-for="(product, index) in products" :key="index"
               class="mb-4 p-4 border rounded-lg bg-gray-50">
            <div class="flex justify-between items-start">
              <div class="flex-grow">
                <div class="font-medium text-lg mb-2">{{ product.name }}</div>
                <div class="text-sm text-gray-600">
                  <div>Type: {{ product.type }}</div>
                  <!-- <div v-if="product.ext_ref_id">Ref ID: {{ product.ext_ref_id }}</div> -->
                </div>
              </div>
              <div class="text-right">
                <div class="mb-1">Quantity: {{ product.quantity }}</div>
                <div class="mb-1">Price: {{ product.price | numFormat("0,0.00") }}</div>
                <div v-if="product.discount && product.discount != '0'" class="mb-1 text-red-600">
                  Discount: -{{ product.discount | numFormat("0,0.00") }}
                </div>
                <div class="font-bold text-lg">
                  Total: {{ product.total | numFormat("0,0.00") }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="text-center py-4 text-gray-500">
          No products found
        </div>

        <div v-if="role == 'so-admin'">
          <hr>
          <div>
            {{ orderData ? orderData : '' }}
          </div>

        </div>

        <div v-if="products && products.length" class="mt-4 border-t pt-4">
          <div class="flex justify-end">
            <div class="text-right">
              <div class="text-lg font-bold">
                Order Total: {{ orderTotal | numFormat("0,0.00") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-button
            style="width: 100%"
            color="primary"
            type="flat"
            @click="showDialog = false"
          >Close</vs-button>
        </vs-col>
      </vs-row>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'ProductListModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderData: {
      type: String,
      default: ''
    },
    orderInfo: {
      type: Object,
      default: () => ({})
    },
    role: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      showDialog: false,
      products: [],
      address: null,
      orderTotal: 0
    }
  },
  watch: {
    show(newVal) {
      this.showDialog = newVal;
      if (newVal) {
        this.parseOrderData();
      }
    },
    showDialog(newVal) {
      if (!newVal) {
        this.$emit('close');
      }
    }
  },
  methods: {
    parseOrderData() {
      try {
        const data = JSON.parse(this.orderData);
        if (data && data.length > 0) {
          const orderData = data[0];

          // Set products
          this.products = orderData.productlist || [];

          // Calculate order total
          this.orderTotal = this.products.reduce((sum, product) => sum + Number(product.total), 0);

          // Set address
          this.address = {
            firstname: this.orderInfo.recipientname ? this.orderInfo.recipientname : orderData.firstname,
            lastname: this.orderInfo.recipientname ? '' : orderData.lastname,
            address: this.orderInfo.address,
            subdistrict: this.orderInfo.subdistrict,
            district: this.orderInfo.district,
            postcode: this.orderInfo.postcode,
            phone: this.orderInfo.recipientphone ? this.orderInfo.recipientphone : orderData.phone,
            note: this.orderInfo.recipientnote
          };
        }
      } catch (e) {
        console.error('Error parsing order data:', e);
        this.products = [];
        this.address = null;
        this.orderTotal = 0;
      }
    }
  }
}
</script>
